<template>
  <div class="gallery">
    <div class="loading" v-if="loading">
      Loading...
    </div>

    <div v-if="error" class="error">
      {{ error }}
    </div>

    <div v-if="gallery" class="gallery-wrapper">
      <div class="content">
        <header class="gallery-header" :style="{ 'border-color': gallery.color, 'background-color': gallery.color + '0d' }">
          <h1 class="gallery__title">{{gallery.name}}</h1>

          <h2 v-if="gallery.galleryLocal" class="gallery__image-count">images ({{ gallery.galleryLocal.length }})</h2>
          <h2 v-if="gallery.galleryLinked" class="gallery__image-count">images ({{ gallery.galleryLinked.length }})</h2>

          <a class="edit-button" target="_blank" v-if="gallery._id" :href="`http://localhost:3333/desk/gallery;${gallery._id}`">Edit</a>
        </header>

        <div class="main-content">
          <ul v-if="gallery.galleryLocal" class="gallery-list local">
            <li v-for="image in gallery.galleryLocal" class="gallery-image">
              <a class="safe-image" :href="imageUrlFor(image.asset)" target="_blank">
                <img v-if="image" class="gallery-image__thumbnail safe-image" :src="imageUrlFor(image.asset).ignoreImageParams().width(480)" />
              </a>
            </li>
          </ul>
          <ul v-if="gallery.galleryLinked" class="gallery-list linked">
            <li v-for="image in gallery.galleryLinked" class="gallery-image">
              <a class="safe-image" :href="image" target="_blank">
                <img v-if="image" class="gallery-image__thumbnail safe-image" :src="image" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sanity from "../sanity";
import imageUrlBuilder from "@sanity/image-url";

const imageBuilder = imageUrlBuilder(sanity);

const query = `*[_type == "gallery" && _id == $id] {
  _id,
  name,
  galleryLinked,
  galleryLocal
}[0]
`;

export default {
  props: {
    id: {
      type: String
    }
  },
  name: "Gallery",
  data() {
    return {
      loading: true,
      gallery: null
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    imageUrlFor(source) {
      return imageBuilder.image(source);
    },
    fetchData() {
      this.error = this.gallery = null;
      this.loading = true;
      sanity.fetch(query, { id: this.id }).then(
        gallery => {
          this.loading = false;
          this.gallery = gallery;
          console.log(gallery);
          console.log(this.gallery);
        },
        error => {
          this.error = error;
        }
      );
    }
  }
};
</script>

<style scoped>
.gallery {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 36px 0;
  grid-gap: 36px;
}
.gallery-wrapper {
  width: 100%;
}
.main-content {
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.main-content h2 {
  margin: 36px 36px 0;
  font-size: 1rem;
}
header.gallery-header {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 5px;
  padding: 24px;
  margin: 0 36px 0;
  min-height: 150px;
  height: 10vw;
  border-width: 1px;
  border-style: solid;
}
.gallery-list {
  display: grid;
  margin: 0;
  padding: 36px;
  grid-gap: 36px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
.gallery-list li {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.gallery-list li a {
  width: 100%;
  display: block;
  text-decoration: none;
}
.gallery__title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--color-mono-0);
  text-decoration: none; 
  margin: 0;
}
.gallery__image-count {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-mono-0);
  text-decoration: none; 
  margin: 0;
}
.gallery-header .edit-button {
  position: absolute;
  top: 24px;
  right: 24px;
  width: auto;
  height: auto;
  margin-right: 0 !important;
}


</style>

